__turbopack_context__.v({
  "circleArrowPlain": "SubNavItems-module-scss-module__vjnATa__circleArrowPlain",
  "circleArrowSolid": "SubNavItems-module-scss-module__vjnATa__circleArrowSolid",
  "groupTrigger": "SubNavItems-module-scss-module__vjnATa__groupTrigger",
  "groupTriggerActive": "SubNavItems-module-scss-module__vjnATa__groupTriggerActive",
  "heading": "SubNavItems-module-scss-module__vjnATa__heading",
  "link": "SubNavItems-module-scss-module__vjnATa__link",
  "newBadge": "SubNavItems-module-scss-module__vjnATa__newBadge",
});
